import FLAG_MAP from '../utils/constants/flags';

export const localStorageService = {
    get:(name:string)=>{
        return localStorage.getItem(name);
    },
    set:(name:string,value:string)=>{
        try {
          const langList = Object.keys(FLAG_MAP);
          value in langList;
         localStorage.setItem(name,value);
        } catch (err) {
            console.error("language unexistant "+ value, err);
        }
    },
      remove: (name:string) => {
    try {
      localStorage.removeItem(name);
    } catch (err) {
      console.error("Erreur suppression localStorage "+ name, err);
    }
  }
}